import { FC } from 'react';
import Hero from 'src/contact-us/components/Hero';
import Resources from 'src/contact-us/components/Resources';
import PitchPageBrowseBoats from 'src/common/components/PitchPageBrowseBoats';
import ReviewAndAppLinks from 'src/common/components/ReviewAndAppLinks';
import SubFooter from 'src/common/components/SubFooter';
import FooterLinks from 'src/common/components/FooterLinks';
import Footer from 'src/common/components/Footer';

const ContactUs: FC = () => (
  <main>
    <Hero />
    <Resources />
    <PitchPageBrowseBoats />
    <Footer>
      <FooterLinks />
      <ReviewAndAppLinks />
      <SubFooter />
    </Footer>
  </main>
);

export default ContactUs;
